import { CustomerInfo } from '@revenuecat/purchases-capacitor';

import { useEffect, useState } from 'react';
import { revenueCatService } from '../../../application/RevenueCatService';
import { AppActionType } from '../context/appContext/actions';
import { useAppContext } from '../context/appContext/context';
import { useRetrieveDriverCredentials } from './useRetrieveDriverCredentials';

type UseRetrieveUserCredentialsResponseProps = {
  isLoading: boolean;
  isInitialized: boolean;
  forceRefetch: () => void;
  data?: CustomerInfo;
};

// Hooks act as 'Adapter' layer.
export const useRetrieveRevenueCatCustomer = (): UseRetrieveUserCredentialsResponseProps => {
  const { appState, appDispatch } = useAppContext();
  const { data: credentials } = useRetrieveDriverCredentials();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const init = async (appUserID: string, phoneNumber: string) => {
    setIsLoading(true);
    await revenueCatService.logIn({ appUserID });
    await revenueCatService.setPhoneNumber(phoneNumber);
    const customerInfo = await revenueCatService.getCustomerInfo();

    appDispatch({ type: AppActionType.SET_REVENUECAT_CUSTOMER, payload: customerInfo });
    setIsLoading(false);
  };

  const forceRefetch = () => {
    if (!credentials) return;
    init(credentials.organization_id, credentials.meta.phone);
  };

  useEffect(() => {
    if (!revenueCatService.isLogged() && credentials?.subscription.isSoloDriversPlan()) {
      init(credentials.organization_id, credentials.meta.phone);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [credentials]);

  return {
    isLoading,
    isInitialized: !!appState.revenueCatCustomer,
    data: appState.revenueCatCustomer,
    forceRefetch,
  };
};
